import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure51 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        backgroundColor:'rgba(255, 255, 255, 0.0)',
        marginTop: 50,
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },

    exporting: {
        enabled: false
    },

    xAxis: [{
        categories: [ 1974, 1978, 1979, 1981, 1983, 1985, 1987, 1989, 1990, 1992, 1995, 1997, 2000, 2004, 2006, 2008, 2009, 2011, 2013, 2015, 2017, 2019 ],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#4472c4'
        },
       lineColor: "#d7d7d7",
       tickColor: "#d7d7d7",
       tickLength: 16,
         labels: {
         y: 32,
           style: {
            fontWeight: 'normal',
              color: '#999999',
               fontSize: '12px'   
    }
},
}
],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: 100,
        min: 0,
        tickInterval: 10,
        title: {
            text: null,
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                //enabled: false,
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            },
        }
    },
    series: [ {
        name: '',
        id: "prev",
        type: 'line',
        color: '#5b9bd5',

        zoneAxis: 'x',
        // zones: [{
        //     value: 13
        // }, {
        //     dashStyle: 'dot'
        // }],

        dataLabels: {
            enabled: false,
            // formatter: function () {
            //     return this.y.toFixed(1)+"%";
            // },
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }

        },

        data: [ 90.00, 91.46, 86.98, 86.42, 83.33, 81.82, 75.68, 73.37, 81.87, 76.78, 74.32, 76.97, 72.79, 76.39, 72.37, 67.02, 69.55, 71.08, 68.00, 66.67, 65.85, 64.60],
    }],

}
